<template>
  <YearMonthSelectPopover
    v-model="yearMonth"
    :yearMonths="yearMonths"
    :disabled="disabled"
    :itemHeight="itemHeight"
    :scrollTo="scrollTo"
  >
    <div :class="['year-month-input', disabled && 'disabled']">
      <CalendarIcon />{{ yearMonth ? format(yearMonth, 'YYYY年M月') : '−−年−−月' }}
    </div>
  </YearMonthSelectPopover>
</template>

<script>
import { format } from 'date-fns'
import YearMonthSelectPopover from '@/components/molecules/YearMonthSelectPopover'
import CalendarIcon from '@/components/icons/CalendarIcon'

/**
 * 年月入力
 */
export default {
  name: 'YearMonthInput',
  components: {
    YearMonthSelectPopover,
    CalendarIcon,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /** 年月 (v-model) */
    value: {
      type: String,
      required: true,
    },
    /** Date型の配列 */
    yearMonths: {
      type: Array,
      required: true,
    },
    /** 非活性フラグ */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** リストアイテムの高さ */
    itemHeight: {
      type: Number,
      required: false,
      default: 64,
    },
    /** スクロール位置(リストアイテム個数) */
    scrollTo: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    yearMonth: {
      get() {
        return this.value
      },
      set(yearMonth) {
        this.$emit('change', yearMonth)
      },
    },
  },
  methods: {
    format,
  },
}
</script>

<style lang="postcss" scoped>
.year-month-input {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  cursor: pointer;
  display: grid;
  fill: var(--brand-color);
  font-size: 15px;
  grid-auto-columns: 24px 1fr;
  grid-auto-flow: column;
  grid-gap: 8px;
  height: 40px;
  padding: 8px;
  width: 100%;

  &.disabled {
    background: var(--very-light-gray-3);
    cursor: default;
    fill: var(--very-dark-gray-2);
  }
}
</style>
